import { env, host, ENV } from '@/utils/env';

const setCookiePath = '/energy/op/cookie/loginIn';

let passport;

const appidMap = {
  [ENV.PROD]: '40015',
  [ENV.PRE]: '40015',
  [ENV.DAILY]: '40015',
};

const query = () =>
  `?appid=${appidMap[env]}&source=${appidMap[env]}&role=423&redirectUrl=` +
  encodeURIComponent(`${host + setCookiePath}?url=${location.href}`);
if (env === ENV.PROD) {
  passport =
    'https://passport.didichuxing.com/common/pc-login/3.0.6/index.html';
} else if (env === ENV.PRE) {
  passport =
    'https://passport.didichuxing.com/common/pc-login/3.0.6/index.html';
} else {
  passport =
    'http://passport-test.didichuxing.com/static/pc-login/3.0.6/index.html';
}

export const loginPath = `${passport}${query()}`;

export const logoutPath = `${passport}${query()}#/logout`;

export function login() {
  location.href = loginPath;
}

export function logout() {
  location.href = logoutPath;
}
